/** @flow */
let getURLTargeted;

const isCli = !(typeof process !== 'undefined' && process.versions && process.versions.node);

if (isCli) {
  // eslint-disable-next-line global-require
  getURLTargeted = (require('./getURL.client').default);
} else {
  // eslint-disable-next-line global-require
  getURLTargeted = (require('./getURL.server').default);
}

export default function getURL(stringToParse) {
  return getURLTargeted(stringToParse);
}
